import { render, staticRenderFns } from "./SitesStatsTable.vue?vue&type=template&id=56ab12e2&"
import script from "./SitesStatsTable.vue?vue&type=script&lang=js&"
export * from "./SitesStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./SitesStatsTable.vue?vue&type=style&index=0&id=56ab12e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports